import { cn } from "@/lib/utils";

export function DripIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path 
        d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"
        className="stroke-[#0A74FF] fill-none"
      />
    </svg>
  );
}
